<app-header></app-header>

<div class="container login-component mt-46 pb-20">
  <div class="ng-row" justify-content-center>
    <div class="ng-col">
      <app-steps stepHeading="AccountRegistration" stepCounter="1"></app-steps>
    </div>
    <div class="ng-col pt-30 pb-30 pd-sm-30" col-6 col-sm-12>
      <div class="font-24 color-010 font-600 mt-5 text-align-center">
        {{ "Pakistannationalitydetails" | translate }}
      </div>

      <form [formGroup]="RegistrationForm">
        <ng-container *ngIf="CardDocumentoption">
          <div class="font-14 color-354 font-400 mt-5 text-align-center">
            {{ "WeneedyourPakistanIDcardto" | translate }}
          </div>
          <div class="form-group mt-20">
            <div class="ng-row">
              <!-- <div class="ng-col mb-10" col-12>
                                <div class="font-15 font-600 color-e76">{{"Select" | translate}}
                                    <span class="color-red"> *</span>
                                </div>
                            </div> -->
              <div class="ng-col" col-6 col-sm-6>
                <div class="custom-checkbox">
                  <input type="radio" value="0" id="label-04" name="Scanidcard" (click)="scanningopt($event, 0)" />
                  <label for="label-04" class="color-black pt-5 pl-35">
                    {{ getText() | translate }}
                  </label>
                </div>
              </div>
              <div class="ng-col pl-15" col-6 col-sm-6>
                <div class="custom-checkbox">
                  <input type="radio" value="1" id="label-05" name="Scanidcard" (click)="scanningopt($event, 1)" />
                  <label for="label-05" class="color-black pt-5 pl-35">
                    {{ "Nadrarecipte" | translate }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="showNadraRecipte">
          <app-attach-box3 attachedHeading="UploadDocument" [AsterikShow]=true (callAnotherFunction)="RemoveFunction()"
            (callParentFunction)="PostToTempImage($event)">
          </app-attach-box3>

          <div class="form-group">
            <button class="btn-dft mt-15" (click)="uploadrecipt()" [disabled]="enableuploadbtn">
              {{ "UploadNadraSlip" | translate }}
            </button>
          </div>
        </ng-container>

        <ng-container *ngIf="ValidIdCard">
          <div class="font-14 color-354 font-400 mt-10">
            {{ "Pleaseenteryour" | translate }}
          </div>

          <div class="form-group mt-42">
            <label>{{ "FirstName" | translate }}</label>
            <input type="text" [(ngModel)]="this.FirstName" maxlength="100" minlength="3" formControlName="FirstName"
              placeholder="Please enter" />
            <ng-container item-content *ngFor="let validation of errorKey.validation_messages.FirstName">
              <span class="error-label" *ngIf="
                  RegistrationForm.controls.FirstName.hasError(
                    validation.type
                  ) &&
                  (RegistrationForm.controls.FirstName.touched || submitAttempt)
                ">
                {{ getMessage(validation.key, "FirstName") }}
              </span>
            </ng-container>
          </div>

          <div class="form-group mt-30">
            <label class="no-mark">{{ "MiddleName" | translate }}</label>
            <input type="text" [(ngModel)]="this.MiddleName" maxlength="100" formControlName="MiddleName"
              placeholder="Please enter" />
            <ng-container item-content *ngFor="let validation of errorKey.validation_messages.MiddleName">
              <span class="error-label" *ngIf="
                  RegistrationForm.controls.MiddleName.hasError(
                    validation.type
                  ) &&
                  (RegistrationForm.controls.MiddleName.touched ||
                    submitAttempt)
                ">
                {{ getMessage(validation.key, "MiddleName") }}
              </span>
            </ng-container>
          </div>

          <div class="form-group mt-30">
            <label>{{ "LastName" | translate }}</label>
            <input type="text" [(ngModel)]="this.LastName" formControlName="LastName" maxlength="100" minlength="3"
              placeholder="Please enter" />
            <ng-container item-content *ngFor="let validation of errorKey.validation_messages.LastName">
              <span class="error-label" *ngIf="
                  RegistrationForm.controls.LastName.hasError(
                    validation.type
                  ) &&
                  (RegistrationForm.controls.LastName.touched || submitAttempt)
                ">
                {{ getMessage(validation.key, "LastName") }}
              </span>
            </ng-container>
          </div>
          <div class="form-group mt-30">
            <label>{{ "FatherH" | translate }}</label>
            <input type="text" [(ngModel)]="this.FatherName" formControlName="FatherName" maxlength="100" minlength="3"
              placeholder="Please enter" />
            <ng-container item-content *ngFor="let validation of errorKey.validation_messages.FatherName">
              <span class="error-label" *ngIf="
                  RegistrationForm.controls.FatherName.hasError(
                    validation.type
                  ) &&
                  (RegistrationForm.controls.FatherName.touched || submitAttempt)
                ">
                {{ getMessage(validation.key, "FatherName") }}
              </span>
            </ng-container>
          </div>


          <div class="form-group mt-30">
            <div class="ng-row">
              <div class="ng-col mb-10" col-12>
                <div class="font-15 font-600 color-e76">
                  {{ "Relation" | translate }}
                  <span class="color-red"> *</span>
                </div>
              </div>
              <div class="ng-col" col-auto>
                <div class="custom-checkbox">
                  <!-- [checked]="isfatherkey"
                   -->
                  <input type="radio" value="1" id="label-08" name="RelationType" (change)="selection(0)"
                    [checked]="isfatherkey" />
                  <label for="label-08" class="color-black pt-5 pl-35">
                    {{ "Father" | translate }}
                  </label>
                </div>
              </div>
              <div class="ng-col pl-15" col-auto>
                <div class="custom-checkbox">
                  <input type="radio" value="0" id="label-09" name="RelationType" [checked]="ishusbandkey"
                    (change)="selection(1)" />
                  <label for="label-09" class="color-black pt-5 pl-35">
                    {{ "Husband" | translate }}
                  </label>
                </div>
              </div>
            </div>
          </div>



          <div class="form-group mt-30" *ngIf="ValidGender">
            <label>{{ "Gender" | translate }}</label>
            <select formControlName="Gender" [(ngModel)]="Gender" [disabled]="ValidGender">
              <option value="{{ this.Gender }}" selected>
                {{ this.Gender }}
              </option>
            </select>
          </div>

          <div class="form-group mt-30" *ngIf="!ValidGender">
            <label>{{ "Gender" | translate }}</label>
            <select formControlName="Gender" [(ngModel)]="Gender" [disabled]="ValidGender" placeholder="Please Select"
              (change)="onChange(Gender)">
              <option value="" disabled selected>Please select</option>
              <option value="M">Male</option>
              <option value="F">Female</option>
            </select>
          </div>

          <div class="form-group mt-30">
            <label>{{ "IDNumber" | translate }}</label>
            <input type="text" formControlName="IDNumber" maxlength="15" minlength="13" [(ngModel)]="this.IDNumber"
              [mask]="this.cardmaask" [placeholder]="this.cardPlaceHolder" />
          </div>

          <div class="form-group mt-30">
            <div class="ng-row">
              <div class="ng-col mb-10" col-12>
                <div class="font-15 font-600 color-e76">
                  {{ "ID Type" | translate }}
                  <span class="color-red"> *</span>
                </div>
              </div>
              <div class="ng-col" col-2 col-sm-3>
                <div class="custom-checkbox">
                  <input [disabled]="!this.isManual" type="radio" value="1" id="label-01" name="nicType"
                    (change)="cnicChange('cnic', true)" [checked]="cnictype" />
                  <label for="label-01" class="color-black pt-5 pl-35">
                    {{ "CNIC" | translate }}
                  </label>
                </div>
              </div>
              <div class="ng-col pl-15" col-2 col-sm-3>
                <div class="custom-checkbox">
                  <input [disabled]="!this.isManual" type="radio" value="0" id="label-02" name="nicType"
                    (change)="cnicChange('scnic', true)" [checked]="snictype" />
                  <label for="label-02" class="color-black pt-5 pl-35">
                    {{ "SNIC" | translate }}
                  </label>
                </div>
              </div>

              <!-- <div class="ng-col pl-15" col-2 col-sm-3>
                            <div class="custom-checkbox pl-15">
                                <input disabled type="radio" value="0" id="label-03" name="nicType"
                                    [checked]="nicoptype">
                                <label for="label-03" class="color-black pt-5 pl-35">
                                    {{"NICOP" | translate}}
                                </label>
                            </div>
                        </div> -->
            </div>
          </div>

          <div class="form-group mt-30">
            <label>{{ "DateofBirth" | translate }}</label>
          </div>

          <div class="ng-row mt-5" justify-content-between>
            <div class="ng-col" col-3 col-sm-12>
              <div class="form-group">
                <select [(ngModel)]="this.DobdaySelect" id="dobdayslist" name="dobdayslist"
                  formControlName="DobdaySelect" (change)="DobSelectionchange()">
                  <!-- <option value="{{ this.DobdaySelect }}" selected>
                    {{ DobdaySelect }}
                  </option> -->

                  <option [ngValue]="a" *ngFor="let a of this.dobdayslistArray">
                    {{ a }}
                  </option>
                </select>
              </div>
              <ng-container item-content *ngFor="
                  let validation of errorKey.validation_messages.DobdaySelect
                ">
                <span class="error-label" *ngIf="
                    RegistrationForm.controls.DobdaySelect.hasError(
                      validation.type
                    ) &&
                    (RegistrationForm.controls.DobdaySelect.touched ||
                      submitAttempt)
                  ">
                  {{ getMessage(validation.key, "DobdaySelect") }}
                </span>
              </ng-container>
            </div>
            <div class="ng-col p-l-r" col-6 col-sm-12>
              <div class="form-group">
                <select [(ngModel)]="this.DobMonthSelect" id="dobmonthlist" name="dobmonthlist"
                  (change)="DobSelectionchange()" formControlName="DobMonthSelect">
                  <!-- <option value="{{ this.DobMonthSelect }}" selected>
                    {{ DobMonthSelect }}
                  </option>
                 -->
                  <option hidden [ngValue]="null" disabled selected>
                    Month
                  </option>
                  <option [ngValue]="a.value" *ngFor="let a of this.dobmonthlistArray">
                    {{ a.text }}
                  </option>
                </select>
              </div>
              <ng-container item-content *ngFor="
                  let validation of errorKey.validation_messages.DobMonthSelect
                ">
                <span class="error-label" *ngIf="
                    RegistrationForm.controls.DobMonthSelect.hasError(
                      validation.type
                    ) &&
                    (RegistrationForm.controls.DobMonthSelect.touched ||
                      submitAttempt)
                  ">
                  {{ getMessage(validation.key, "DobMonthSelect") }}
                </span>
              </ng-container>
            </div>
            <div class="ng-col" col-3 col-sm-12>
              <div class="form-group">
                <select [(ngModel)]="this.DobYearSelect" formControlName="DobYearSelect"
                  (change)="DobSelectionchange()">
                  <!-- <option value="{{ this.DobYearSelect }}" selected>
                    {{ DobYearSelect }}
                  </option> -->
                  <option hidden [ngValue]="null" disabled selected>
                    Year
                  </option>
                  <option [ngValue]="a" *ngFor="let a of this.dobmaxarray">
                    {{ a }}
                  </option>
                </select>
              </div>
              <ng-container item-content *ngFor="
                  let validation of errorKey.validation_messages.DobYearSelect
                ">
                <span class="error-label" *ngIf="
                    RegistrationForm.controls.DobYearSelect.hasError(
                      validation.type
                    ) &&
                    (RegistrationForm.controls.DobYearSelect.touched ||
                      submitAttempt)
                  ">
                  {{ getMessage(validation.key, "DobYearSelect") }}
                </span>
              </ng-container>
            </div>
          </div>
          <div class="form-group" *ngIf="this.doeError">
            <span class="error-label" *ngIf="this.dobError">{{
              "DateOfBirthError" | translate
              }}</span>
          </div>
          <div class="form-group mt-30">
            <div class="ng-row">
              <div class="ng-col mb-10" col-12>
                <div class="font-15 font-600 color-e76">
                  {{ "IsLifeTimeCnic" | translate }}
                  <span class="color-red"> *</span>
                </div>
              </div>
              <div class="ng-col" col-2 col-sm-3>
                <div class="custom-checkbox">
                  <input [disabled]="!this.isManual" type="radio" id="label-1"
                    (change)="lifeTimeChange('lifetime', true)" [checked]="IslifeTime" />
                  <label for="label-1" class="color-black pt-5 pl-35">
                    {{ "Yes" | translate }}
                  </label>
                </div>
              </div>
              <div class="ng-col pl-15" col-2 col-sm-3>
                <div class="custom-checkbox">
                  <input [disabled]="!this.isManual" type="radio" id="label-2"
                    (change)="lifeTimeChange('nolifetime', false)" [checked]="IsNotlifeTime" />
                  <label for="label-2" class="color-black pt-5 pl-35">
                    {{ "No" | translate }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="this.showdoe">
            <div class="form-group mt-30">
              <label>{{ "IDExpiry" | translate }}</label>
            </div>

            <div class="ng-row mt-5" justify-content-between>
              <div class="ng-col" col-3 col-sm-12>
                <div class="form-group">
                  <select id="doedayslist" name="doedayslist" formControlName="DoedaySelect"
                    [(ngModel)]="this.DoedaySelect" (change)="DoeSelectionchange()">
                    <option hidden [ngValue]="null" disabled selected>
                      Date
                    </option>
                    <option [ngValue]="a" *ngFor="let a of this.doedayslistArray">
                      {{ a }}
                    </option>
                    <!-- <option value="{{ DoedaySelect }}" selected>
                      {{ DoedaySelect }}
                    </option> -->
                  </select>
                </div>
                <ng-container item-content *ngFor="
                    let validation of errorKey.validation_messages.DoedaySelect
                  ">
                  <span class="error-label" *ngIf="
                      RegistrationForm.controls.DoedaySelect.hasError(
                        validation.type
                      ) &&
                      (RegistrationForm.controls.DoedaySelect.touched ||
                        submitAttempt)
                    ">
                    {{ getMessage(validation.key, "DoedaySelect") }}
                  </span>
                </ng-container>
              </div>
              <div class="ng-col p-l-r" col-6 col-sm-12>
                <div class="form-group">
                  <select id="doemonthlist" name="doemonthlist" formControlName="DoeMonthSelect"
                    [(ngModel)]="this.DoeMonthSelect" (change)="DoeSelectionchange()">
                    <option hidden [ngValue]="null" disabled selected>
                      Month
                    </option>
                    <option [ngValue]="a.value" *ngFor="let a of this.doemonthlistArray">
                      {{ a.text }}
                    </option>
                  </select>
                </div>
                <ng-container item-content *ngFor="
                    let validation of errorKey.validation_messages
                      .DoeMonthSelect
                  ">
                  <span class="error-label" *ngIf="
                      RegistrationForm.controls.DoeMonthSelect.hasError(
                        validation.type
                      ) &&
                      (RegistrationForm.controls.DoeMonthSelect.touched ||
                        submitAttempt)
                    ">
                    {{ getMessage(validation.key, "DoeMonthSelect") }}
                  </span>
                </ng-container>
              </div>
              <div class="ng-col" col-3 col-sm-12>
                <div class="form-group">
                  <select [(ngModel)]="this.DoeYearSelect" (change)="DoeSelectionchange()"
                    formControlName="DoeYearSelect">
                    <option hidden [ngValue]="null" disabled selected>
                      Year
                    </option>
                    <option [ngValue]="a" *ngFor="let a of this.doeyears">
                      {{ a }}
                    </option>
                  </select>
                </div>
                <ng-container item-content *ngFor="
                    let validation of errorKey.validation_messages.DoeYearSelect
                  ">
                  <span class="error-label" *ngIf="
                      RegistrationForm.controls.DoeYearSelect.hasError(
                        validation.type
                      ) &&
                      (RegistrationForm.controls.DoeYearSelect.touched ||
                        submitAttempt)
                    ">
                    {{ getMessage(validation.key, "DoeYearSelect") }}
                  </span>
                </ng-container>
              </div>
            </div>
            <div class="form-group" *ngIf="this.doeError">
              <span class="error-label">{{ "DOEerror" | translate }}</span>
            </div>
          </div>

          <div class="form-group mt-30">
            <label class="no-mark">{{ "IssuanceDate" | translate }}</label>
          </div>

          <div class="ng-row mt-5" justify-content-between>
            <div class="ng-col" col-3 col-sm-12>
              <div class="form-group">
                <select [(ngModel)]="this.issuedaySelect" id="issuedayslist" name="issuedayslist"
                  (change)="issueSelectionchange()" formControlName="issuedaySelect">
                  <option hidden [ngValue]="null" disabled selected>
                    Date
                  </option>
                  <option [ngValue]="a" *ngFor="let a of this.issuedayslistArray">
                    {{ a }}
                  </option>
                </select>
              </div>
              <ng-container item-content *ngFor="
                  let validation of errorKey.validation_messages.issuedaySelect
                ">
                <span class="error-label" *ngIf="
                    RegistrationForm.controls.issuedaySelect.hasError(
                      validation.type
                    ) &&
                    (RegistrationForm.controls.issuedaySelect.touched ||
                      submitAttempt)
                  ">
                  {{ getMessage(validation.key, "issuedaySelect") }}
                </span>
              </ng-container>
            </div>
            <div class="ng-col p-l-r" col-6 col-sm-12>
              <div class="form-group">
                <select [(ngModel)]="this.issueMonthSelect" id="issuemonthlist" name="issuemonthlist"
                  (change)="issueSelectionchange()" formControlName="issueMonthSelect">
                  <option hidden [ngValue]="null" disabled selected>
                    Month
                  </option>
                  <option [ngValue]="a.value" *ngFor="let a of this.issuemonthlistArray">
                    {{ a.text }}
                  </option>
                </select>
              </div>
            </div>
            <div class="ng-col" col-3 col-sm-12>
              <div class="form-group">
                <select [(ngModel)]="this.issueYearSelect" formControlName="issueYearSelect"
                  (change)="issueSelectionchange()">
                  <option hidden [ngValue]="null" disabled selected>
                    Year
                  </option>
                  <option [ngValue]="a" *ngFor="let a of this.issuedateyears">
                    {{ a }}
                  </option>
                </select>
              </div>
              <ng-container item-content *ngFor="
                  let validation of errorKey.validation_messages.issueYearSelect
                ">
                <span class="error-label" *ngIf="
                    RegistrationForm.controls.issueYearSelect.hasError(
                      validation.type
                    ) &&
                    (RegistrationForm.controls.issueYearSelect.touched ||
                      submitAttempt)
                  ">
                  {{ getMessage(validation.key, "issueYearSelect") }}
                </span>
              </ng-container>
            </div>
          </div>
          <div class="form-group" *ngIf="this.doeError">
            <span class="error-label" *ngIf="this.IssueError">{{
              "IssueError" | translate
              }}</span>
          </div>

          <div class="form-group mt-46" *ngIf="UserRegister">
            <button class="btn-dft mt-15" [disabled]="isFormValid()" (click)="RegisterUser()">
              {{ "Continue" | translate }}
            </button>
          </div>

          <div class="font-14 color-354 font-400 mt-20" *ngIf="showscanid && this.isManual == false">
            Please review and validate the information captured above from your
            ID card. Incase of the information captured above is not displayed
            correctly, then please click on 'Scan Again' button below
          </div>

          <div class="form-group">
            <ng-container item-content *ngIf="showscanid">
              <button class="btn-dft-white mt-15" *ngIf="ScanID" (click)="IDCard()">
                {{ "ScanAgain" | translate }}
              </button>

              <button class="btn-dft mt-15" *ngIf="Selfiescan" (click)="RegisterUser()">
                {{ "Continue" | translate }}
              </button>
            </ng-container>
            <!-- <button class="btn-dft mt-15" *ngIf="!ScanID" [disabled]="ScanView" (click)="Scanidcard()">
                            {{"ScanID" | translate}}
                        </button>
                     <button class="btn-dft mt-15" (click)="mainupload()">
                            {{"ScanID" | translate}}
                        </button> -->
          </div>

          <div class="ng-row mt-30" col-space>
            <div class="ng-col mt-30" col-4 *ngIf="this.front">
              <div class="ready-img-box">
                <img [src]="front" alt="" />
              </div>
            </div>
            <div class="ng-col mt-30" col-4 *ngIf="this.back">
              <div class="ready-img-box">
                <img [src]="back" alt="" />
              </div>
            </div>
            <div class="ng-col mt-30" col-4 *ngIf="this.face">
              <div class="ready-img-box">
                <img [src]="face" alt="" />
              </div>
            </div>
          </div>
        </ng-container>
      </form>
      <div>
        <div id="idwise-mount"></div>
      </div>
      <div class="hidden mt-25" id="show-upload-card">
        <div class="border border-color-e1e br-12 bg-white pd attach-box mt-25">
          <div class="ng-row p-l-r" justify-content-between align-item-center>
            <div class="ng-col" col-12 col-sm-12>
              <div class="font-18 font-600 color-6F2">
                {{ "FrontIDCard" | translate }} <span class="color-red">*</span>
              </div>
              <div class="font-16 font-400 color-354 mt-5">
                {{ "PakistanIDCardfrontimage" | translate }}
              </div>

              <div class="font-16 font-400 color-red mt-5" *ngIf="this.imageErrorfront">
                {{ imageErrorfront }}
              </div>
            </div>
            <div class="ng-col mt-25" col-auto col-sm-12>
              <div class="custom-file-uploader">
                <div class="ng-row" align-item-center>
                  <!-- After Attach -->
                  <div class="ng-col pr-15" col-auto *ngIf="isImageSaved">
                    <i class="icon-green-check-big-2"></i>
                  </div>
                  <!-- After Attach -->

                  <div class="ng-col pr-15" col-auto id="screen-start-front">
                    <input id="image-file-front-side" type="file" accept="image/*"
                      (change)="fileChangeEvent($event, 'front')" />
                    <label for="image-file-front-side">Attach</label>
                  </div>

                  <!-- After Attach -->
                  <div class="ng-col" col-auto *ngIf="isImageSaved">
                    <label (click)="showPopupAttachfront()" class="active">View</label>
                  </div>
                  <!-- After Attach -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="border border-color-e1e br-12 bg-white pd attach-box mt-25">
          <div class="ng-row p-l-r" justify-content-between align-item-center>
            <div class="ng-col" col-12 col-sm-12>
              <div class="font-18 font-600 color-6F2">
                {{ "BackIDCard" | translate }} <span class="color-red">*</span>
              </div>
              <div class="font-16 font-400 color-354 mt-5">
                {{ "PakistanIDCardbackimage" | translate }}
              </div>

              <div class="font-16 font-400 color-red mt-5" *ngIf="this.imageErrorback">
                {{ imageErrorback }}
              </div>
            </div>
            <div class="ng-col mt-25" col-auto col-sm-12>
              <div class="custom-file-uploader">
                <div class="ng-row" align-item-center>
                  <!-- After Attach -->
                  <div class="ng-col pr-15" col-auto *ngIf="isImageSaved1">
                    <i class="icon-green-check-big-2"></i>
                  </div>
                  <!-- After Attach -->
                  <!-- capture="environment" -->
                  <div class="ng-col pr-15" col-auto id="screen-start-back">
                    <input id="image-file-back-side" type="file" accept="image/*"
                      (change)="fileChangeEvent($event, 'back')" />
                    <label for="image-file-back-side">Attach</label>
                  </div>

                  <!-- After Attach -->
                  <div class="ng-col" col-auto *ngIf="isImageSaved1">
                    <label (click)="showPopupAttachback()" class="active">View</label>
                  </div>
                  <!-- After Attach -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <button *ngIf="this.isManual == false" class="btn-dft mt-15" [disabled]="ScanViewUpload()"
          (click)="mainupload()">
          {{ "ScanID" | translate }}
        </button>
        <button *ngIf="this.isManual == true" class="btn-dft mt-15" [disabled]="ScanViewUpload()"
          (click)="NextManual()">
          {{ "Next" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div id="screen-scanning" class="hidden">
  <!-- <i class="icon-circle-close close-icon"></i> -->

  <video id="camera-feed" playsinline></video>

  <canvas id="camera-feedback"></canvas>

  <div class="reticle-container">
    <div class="reticle is-classification">
      <div class="reticle__cursor">
        <div class="reticle__el"></div>
        <div class="reticle__el"></div>
        <div class="reticle__el"></div>
        <div class="reticle__el"></div>
      </div>
    </div>
    <p class="message" id="camera-guides">{{ scanFeedbacktxt }}</p>
  </div>
</div>

<app-fab></app-fab>

<div class="custom-modal auto-resize camera-view-modal" #modal3>
  <div class="custom-modal-overlay"></div>
  <div class="custom-modal-canvas">
    <div class="custom-modal-canvas-scroller">
      <div></div>

      <div class="custom-modal-img-box">
        <ng-container *ngIf="
            this.deviceInfo.device == 'iPhone' ||
            this.deviceInfo.deviceType == 'desktop'
          ">
          <img id="id" #imageid2 alt="" style="transform: scaleX(-1)" width="" height="150" />
        </ng-container>
        <ng-container *ngIf="this.deviceInfo.device == 'Android'">
          <img [src]="this.webcamImage" height="150" tyle="transform: scaleX(-1);" />
        </ng-container>
      </div>
    </div>
  </div>

  <div class="custom-modal-footer">
    <div class="ng-row" justify-content-center>
      <div class="ng-col pd" col-auto>
        <button class="btn-dft" (click)="retake()">
          {{ "Retake" | translate }}
        </button>
      </div>
      <div class="ng-col pd" col-auto>
        <button class="btn-dft" (click)="selfiedone()">
          {{ "Ok" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="custom-modal auto-resize camera-modal" #modal2>
  <div class="custom-modal-overlay"></div>
  <div class="custom-modal-canvas p-0">
    <ng-container *ngIf="
        this.deviceInfo.device == 'iPhone' ||
        this.deviceInfo.deviceType == 'desktop'
      ">
      <webcam [allowCameraSwitch]="true" [switchCamera]="true" *ngIf="this.cameraactive" mirrorImage="always"
        [imageQuality]="1" [height]="100" [width]="200" [trigger]="triggerObservable"
        (imageCapture)="handleImage($event)">
      </webcam>
    </ng-container>

    <ng-container *ngIf="this.deviceInfo.device == 'Android'">
      <div class="video-container video-container-box selfie-video" *ngIf="!error">
        <video [class.show]="!isCaptured" [class.hide]="isCaptured" #video id="videocamera" autoplay></video>
        <canvas [class.show]="isCaptured" [class.hide]="!isCaptured" #canvas id="canvascamera" [width]="WIDTH"
          [height]="HEIGHT"></canvas>
      </div>
    </ng-container>
  </div>
  <div class="custom-modal-footer">
    <div class="ng-row" justify-content-center>
      <div class="ng-col pd" col-auto>
        <ng-container *ngIf="
            this.deviceInfo.device == 'iPhone' ||
            this.deviceInfo.deviceType == 'desktop'
          ">
          <button class="btn-dft-white" (click)="triggerSnapshot()">
            {{ "Capture" | translate }}
          </button>
        </ng-container>
        <ng-container *ngIf="this.deviceInfo.device == 'Android'">
          <button class="btn-dft-white" (click)="handleImage($event)">
            {{ "Capture" | translate }}
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<div class="custom-modal text-modal full-height" #ModalNadraslip>
  <div class="custom-modal-overlay"></div>
  <div class="custom-modal-canvas">
    <div class="custom-modal-canvas-scroller">
      <div class="ng-row mt-42" justify-content-center>
        <div class="custom-modal-canvas-scroller">
          <!--  <app-attach-box3 attachedHeading="UploadDocument" [AsterikShow]=true
                        (callAnotherFunction)="RemoveFunction()" (callParentFunction)="PostToTempImage($event)">
                    </app-attach-box3>-->

          <div class="form-group">
            <button class="btn-dft mt-15" (click)="uploadrecipt()" [disabled]="enableuploadbtn">
              {{ "UploadNadraSlip" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="custom-modal text-modal full-height" #modal>
  <div class="custom-modal-overlay"></div>
  <div class="custom-modal-canvas">
    <div class="custom-modal-close" *ngIf="close">
      <i class="icon-close-black" (click)="hidePopup()"></i>
    </div>
    <div class="custom-modal-canvas-scroller">
      <div class="font-16 font-600 color-010 line-h-25">
        {{ "ScanIDNotes" | translate }}
      </div>
      <div class="font-14 font-400 color-010 line-h-26 mt-15">
        {{ "Foroptimaldataextraction" | translate }}
      </div>

      <div class="ng-row mt-30" align-item-center>
        <div class="ng-col" col-auto>
          <i class="icon-bulb"></i>
        </div>
        <div class="ng-col" col-9>
          <div class="font-14 font-500 color-f52 line-h-25 p-l-r">
            {{ "Pleasemakesure" | translate }}
          </div>
        </div>
      </div>

      <div class="ng-row mt-15" align-item-center>
        <div class="ng-col" col-auto>
          <i class="icon-fram"></i>
        </div>
        <div class="ng-col" col-9>
          <div class="font-14 font-500 color-f52 line-h-25 p-l-r">
            {{ "PlaceyourID" | translate }}
          </div>
        </div>
      </div>

      <div class="ng-row mt-15" align-item-center>
        <div class="ng-col" col-auto>
          <i class="icon-tick-black"></i>
        </div>
        <div class="ng-col" col-9>
          <div class="font-14 font-500 color-f52 line-h-25 p-l-r">
            {{ "Oncefit" | translate }}
          </div>
        </div>
      </div>

      <div class="font-14 font-400 color-010 line-h-26 mt-15">
        {{ "NotePleaseusecamera" | translate }}
      </div>

      <div class="form-group mt-42 custom-checkbox">
        <input type="checkbox" [(ngModel)]="this.Acceptcondition" id="check1" (change)="changeAgree($event)" />
        <label for="check1" class="line-h-20">
          {{ "Iconfirmthat" | translate }}
          <span class="label-link color-6F2" (click)="labelLink($event)">{{
            "guidelines" | translate
            }}</span>
        </label>
      </div>

      <div class="ng-row mt-42" justify-content-center>
        <div class="ng-col" col-9 col-sm-12>
          <div class="form-group">
            <button class="btn-dft mt-15" [disabled]="agreevalid()" *ngIf="!ScanID" (click)="IDCard()">
              {{ "ScanmyID" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="custom-modal text-modal full-height" #modal4>
  <div class="custom-modal-overlay"></div>
  <div class="custom-modal-canvas">
    <div class="custom-modal-close">
      <i class="icon-close-black" (click)="hidePopup4()"></i>
    </div>
    <div class="custom-modal-canvas-scroller">
      <div class="font-24 font-600 color-010 line-h-25">
        {{ "SelfieLivelinessTest" | translate }}
      </div>

      <div class="ng-row mt-30" align-item-center>
        <div class="ng-col" col-auto>
          <i class="icon-bulb"></i>
        </div>
        <div class="ng-col" col-9>
          <div class="font-14 font-500 color-f52 line-h-25 p-l-r">
            {{ "Pleaseensure" | translate }}
          </div>
        </div>
      </div>

      <div class="ng-row mt-15" align-item-center>
        <div class="ng-col" col-auto>
          <i class="icon-bulb"></i>
        </div>
        <div class="ng-col" col-9>
          <div class="font-14 font-500 color-f52 line-h-25 p-l-r">
            {{ "Pleaseensureyou" | translate }}
          </div>
        </div>
      </div>

      <div class="ng-row mt-15" align-item-center>
        <div class="ng-col" col-auto>
          <i class="icon-fram"></i>
        </div>
        <div class="ng-col" col-9>
          <div class="font-14 font-500 color-f52 line-h-25 p-l-r">
            {{ "Pleaselookinto" | translate }}
          </div>
        </div>
      </div>

      <div class="ng-row mt-15" align-item-center>
        <div class="ng-col" col-auto>
          <i class="icon-tick-black"></i>
        </div>
        <div class="ng-col" col-9>
          <div class="font-14 font-500 color-f52 line-h-25 p-l-r">
            {{ "Pleaseremoveany" | translate }}
          </div>
        </div>
      </div>

      <!-- <div class="font-14 font-400 color-010 line-h-26 mt-30">
        {{ "NoteTheuseof" | translate }}
      </div> -->

      <!-- <div class="form-group mt-30 custom-checkbox">
        <input
          type="checkbox"
          [(ngModel)]="this.livenessagree"
          id="check2"
          (change)="livnessagree($event)"
        />
        <label for="check2" class="line-h-20">
          {{ "Iconfirmthat" | translate }}
          <span class="label-link color-6F2" (click)="labelLink2($event)">{{
            "guidelines" | translate
          }}</span>
        </label>
      </div> -->

      <!-- ye button per lagy ga -->
      <!-- [disabled]="livnessagreevalid()" -->

      <div class="ng-row mt-30" justify-content-center>
        <div class="ng-col" col-6 col-sm-12>
          <div class="form-group">
            <button class="btn-dft mt-15" (click)="showPopup1()">
              {{ "OK" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="custom-modal auto-resize" #modalAttachfront>
  <div class="custom-modal-overlay" (click)="hidePopupAttachfront()"></div>
  <div class="custom-modal-canvas">
    <div class="custom-modal-canvas-scroller">
      <div class="custom-modal-img-box hidden" id="start-front">
        <img id="front-image" alt="" width="auto" />
      </div>
      <div class="custom-modal-img-box" id="start-front">
        <img [src]="frontimagebase641" alt="" width="auto" />
      </div>
    </div>
  </div>

  <div class="custom-modal-footer">
    <div class="ng-row" justify-content-center>
      <div class="ng-col pd" col-auto>
        <button class="btn-dft-white" (click)="removeAttachImagefront()">
          {{ "Delete" | translate }}
        </button>
      </div>
      <div class="ng-col pd" col-auto>
        <button class="btn-dft" (click)="hidePopupAttachfront()">
          {{ "Close" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="custom-modal auto-resize" #modalAttachback>
  <div class="custom-modal-overlay" (click)="hidePopupAttachback()"></div>
  <div class="custom-modal-canvas">
    <div class="custom-modal-canvas-scroller">
      <div class="custom-modal-img-box">
        <div class="custom-modal-img-box hidden" id="start-back">
          <img id="back-image" alt="" width="auto" />
        </div>
        <div class="custom-modal-img-box" id="start-back">
          <img [src]="backimagebase641" alt="" width="auto" />
        </div>
      </div>
    </div>
  </div>

  <div class="custom-modal-footer">
    <div class="ng-row" justify-content-center>
      <div class="ng-col pd" col-auto>
        <button class="btn-dft-white" (click)="removeAttachImageback()">
          {{ "Delete" | translate }}
        </button>
      </div>
      <div class="ng-col pd" col-auto>
        <button class="btn-dft" (click)="hidePopupAttachback()">
          {{ "Close" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Please Wait...</p>
</ngx-spinner> -->